export class RateLimiter {
  private static instance: RateLimiter;
  private lastCallTime: { [key: string]: number } = {};
  private readonly minInterval = 2000; // 2 seconds between calls

  private constructor() {}

  public static getInstance(): RateLimiter {
    if (!RateLimiter.instance) {
      RateLimiter.instance = new RateLimiter();
    }
    return RateLimiter.instance;
  }

  public async checkRateLimit(key: string): Promise<void> {
    const now = Date.now();
    const lastCall = this.lastCallTime[key] || 0;
    const timeSinceLastCall = now - lastCall;

    if (timeSinceLastCall < this.minInterval) {
      const timeToWait = this.minInterval - timeSinceLastCall;
      await new Promise((resolve) => setTimeout(resolve, timeToWait));
    }

    this.lastCallTime[key] = Date.now();
  }
}
